import React, { Component } from "react"
import PropTypes from "prop-types"
import { BackgroundImage } from "containers"
import Radium from "higher-order-components/configured-radium/"

/** Renders a set of background images */
class LayeredBackgroundImage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      bottom: props.imageSrc
    }
  }
  componentWillReceiveProps(newProps) {
    const { imageSrc } = this.props
    if (newProps.imageSrc !== imageSrc) {
      this.setState({ bottom: imageSrc, top: false }, () => {
        this.setState({ top: newProps.imageSrc })
      })
    }
  }
  /**
   * @param {String} src - URL for image asset.
   * @returns {ReactElement} React Component
   */
  render() {
    const { top, bottom } = this.state
    const { backgroundSize, fill, transition } = this.props
    return (
      <div
        style={[
          { position: "relative", zIndex: 0 },
          fill && {
            height: "100%",
            width: "100%"
          }
        ]}
        data-test="layered-background-image">
        <div style={[styles.base]}>
          {top && (
            <BackgroundImage
              backgroundSize={backgroundSize}
              src={top}
              position={"absolute"}
              transition={transition}
              zIndex={2} />
          )}
          {bottom && (
            <BackgroundImage backgroundSize={backgroundSize} src={bottom} position={"absolute"} transition={transition} />
          )}
        </div>
        <img style={{ opacity: 0, height: "auto", maxWidth: "100%" }} src={bottom} />
      </div>
    )
  }
}
const styles = {
  base: {
    height: "100%",
    width: "100%",
    position: "absolute",
    pointerEvents: "none"
  }
}

LayeredBackgroundImage.propTypes = {
  imageSrc: PropTypes.string,
  transition: PropTypes.object,
  backgroundSize: PropTypes.oneOf(["contain", "cover"]),
  fill: PropTypes.bool
}

export default Radium(LayeredBackgroundImage)



// WEBPACK FOOTER //
// ./src/containers/layered-background-image/index.jsx